import React from "react";
import {Button, Container, Divider, Grid, Header, Icon, Segment} from "semantic-ui-react";

import icon1 from './../../../images/create-your-team.png';
import icon2 from './../../../images/custom-project.png';
import ProgressContainer from "../../Progress/ProgressContainer";

class Variety extends React.Component {

    componentDidMount() {
        if (!this.props.flow.variety) {
            this.props.scrollToStep(2);
        }
    }

    render() {
        return (
            <div id={'variety'} className={'step-section'}>
                <Grid>
                    <Grid.Column padded={'horizontally'}>
                        <Container className={"pre-header"}>
                            <h2>IT Team Cost Calculator</h2>
                            <h4>With Intersog, you get access to <strong>250+</strong> top software developers ready to commit from day one.</h4>
                        </Container>
                        <ProgressContainer/>
                        <Segment placeholder>
                            <Grid columns={2} stackable>
                                <Divider vertical>Or</Divider>
                                <Grid.Row className={`variety`} verticalAlign='middle'>
                                    <Grid.Column className={`team`}>
                                        <Header icon>
                                            <img src={icon1} />
                                            <h3>Create Your Team</h3>
                                        </Header>
                                        <Button className={'intersog-btn'} onClick={() => {
                                            this.props.setNextStep(3);
                                            this.props.changeStep();
                                            this.props.setVariety("team");
                                            this.props.scrollToStep(3);
                                        }}>Create</Button>
                                    </Grid.Column>
                                    <Grid.Column className={`project`}>
                                        <Header icon>
                                            <img src={icon2} />
                                            <h3>Build a Custom Project</h3>
                                        </Header>
                                        <Button className={`intersog-btn`} disabled={false} onClick={() => {
                                            this.props.setNextStep(7);
                                            this.props.changeStep();
                                            this.props.setVariety("project");
                                            this.props.scrollToStep(7);
                                        }}>Request Sales</Button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

export default Variety;